<template>
  <nav v-if="route.path !== '/home'" class="navbar">
    <router-link to="/home">← Powrót do menu </router-link>
  </nav>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

onMounted(() => {
  if (route.path === "/home") {
    location.reload();
  }

  const allPuzzlesCompleted = [
    "puzzle1",
    "puzzle2",
    "puzzle3",
    "puzzle4",
  ].every((puzzle) => document.cookie.includes(`${puzzle}=completed`));

  if (route.path === "/congrats" && !allPuzzlesCompleted) {
    router.push("/home");
  }
});
</script>

<style>
.home {
  text-align: center;
  padding: 40px 20px 40px 20px;
  height: 100%;
  color: #1b5e20;
  font-family: "Roboto", sans-serif;
}
</style>
